import { Link } from "react-router-dom";
import { getFilmsByIds } from "@/lib/film";
import { topics } from "@/mocks/topics";

export default function TopicPreview() {
  const preview = topics.slice(0, 3);

  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6 md:mb-8">
          <div>
            <p className="text-[11px] tracking-[0.24em] text-primary-600 uppercase mb-2 font-label">COLLECTIONS</p>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950">精选专题</h2>
            <p className="mt-2 text-sm text-foreground-600">按主题整理的片单，从时代、城市与情绪出发。</p>
          </div>
          <Link
            to="/topic"
            className="inline-flex items-center gap-1 text-sm text-foreground-700 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            全部专题
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {preview.map((topic) => {
            const covers = getFilmsByIds(topic.groups.flatMap((group) => group.filmIds)).slice(0, 3);
            return (
              <Link
                key={topic.id}
                to={`/topic?t=${topic.id}`}
                className="group p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-heading text-base md:text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {topic.title}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-500">{topic.subtitle}</p>
                  </div>
                  <span className="w-8 h-8 shrink-0 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center">
                    <i className="ri-bookmark-line text-sm w-4 h-4 flex items-center justify-center"></i>
                  </span>
                </div>

                <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-2">{topic.intro}</p>

                <div className="mt-4 flex items-center gap-2">
                  {covers.map((film) => (
                    <div key={film.id} className="w-14 h-20 rounded-md overflow-hidden bg-background-200 shrink-0">
                      <img
                        src={film.cover}
                        alt={`${film.title} 影片封面`}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  ))}
                  <span className="ml-auto text-xs text-foreground-500 font-label">
                    共 {topic.groups.reduce((total, group) => total + group.filmIds.length, 0)} 部
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}